import * as actions from './actionTypes';

export function validateLoggedIn() {
  return { type: actions.VALIDATE_LOGGEDIN };
}

export function validateLoggedInSuccess(checkSession) {
  const {
    isLoggedIn,
    timeLeft,
    sonnetAddressBookUid,
    email,
    preferredLang,
    userId,
  } = checkSession;

  return {
    type: actions.VALIDATE_LOGGEDIN_SUCCESS,
    payload: {
      isLoggedIn,
      timeLeft,
      sonnetAddressBookUid,
      email,
      preferredLang,
      userId,
    },
  };
}

export const validateLoggedInFailed = (error) => ({
  type: actions.VALIDATE_LOGGEDIN_FAILED,
  payload: { error },
});

export const logout = () => ({
  type: actions.LOGOUT,
});

export const logoutSuccess = () => ({
  type: actions.LOGOUT_SUCCESS,
});

export const logoutFailed = (error) => ({
  type: actions.LOGOUT_FAILED,
  payload: { error },
});

export const changeLanguage = (preferredLang) => ({
  type: actions.CHANGE_LANGUAGE,
  payload: { preferredLang },
});

export const clearValidateLoggedInError = () => ({ type: actions.CLEAR_VALIDATE_LOGGEDIN_ERROR });
